import React from 'react';
import {Detection} from '../../../../utils/detection';
// import {UpgradeBrowsers} from '../../';
import VideoServiceNG from '../../../../utils/videoServiceNg';

export default function UpgradeBrowsersWrapper(WrappingComponent) {
  // const {
  //   isPhone,
  //   os: {name: os},
  // } = Detection;
  const UpgradeBrowsersComponent = props => (
    VideoServiceNG.checkSystemRequirements() && Detection.isSupported
      ? <WrappingComponent {...props}/>
      : <WrappingComponent {...props}/>
      // : <UpgradeBrowsers os={os} isPhone={isPhone}/>
  );

  return UpgradeBrowsersComponent;
}
